var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "flex-start-center color-2 mr-10" }, [
    _c("i", {
      staticClass: "fa fa-tag mr-5",
      attrs: { "aria-hidden": "true" },
    }),
    _c("span", [_vm._v(_vm._s(_vm.labelPromotion))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }